import * as Styled from './CookieConsentStyles';
import CheckboxUnchecked from '../../../images/checkbox-unchecked.png';
import CheckboxChecked from '../../../images/checkbox-checked.png';

const CookieOptions = ({ isOpen, settings, onChange, onSave }: any) => {

  return (
    <Styled.OptionsContainer className={isOpen ? 'open' : ''}>
      <Styled.Option>
        <Styled.OptionHeader>
          <span>
            Essential Cookies
            <Styled.Highlight> (always active)</Styled.Highlight>
          </span>
          <Styled.Checkbox
            src={CheckboxChecked}
            style={{ opacity: 0.3 }}
            alt="essential checked"
          />
        </Styled.OptionHeader>
        <Styled.Explanation>
          These cookies are required to perform basic website functionality.
        </Styled.Explanation>
      </Styled.Option>
      {/*<Styled.Option>
        <Styled.OptionHeader>
          <span>Functional Cookies</span>
          <Styled.Checkbox
            src={settings.functional ? CheckboxChecked : CheckboxUnchecked}
            alt="functional check"
            onClick={() => onChange('functional')}
          />
        </Styled.OptionHeader>
        <Styled.Explanation>
          These cookies allow us to personalize content for you, remember your preferences, and improve your search experience.        </Styled.Explanation>
      </Styled.Option>*/}
      <Styled.Option>
        <Styled.OptionHeader>
          <span>Analytics Cookies</span>
          <Styled.Checkbox
            src={settings.analytics ? CheckboxChecked : CheckboxUnchecked}
            alt="analytics check"
            onClick={() => onChange('analytics')}
          />
        </Styled.OptionHeader>
        <Styled.Explanation>
          These cookies provide you with a seamless and intuitive experience by giving us insights into how you interact and navigate the website.
        </Styled.Explanation>
      </Styled.Option>
      <div className="text-center">
        <Styled.AcceptBtn onClick={onSave}>
          Save
        </Styled.AcceptBtn>
      </div>
    </Styled.OptionsContainer>
  )
}

export default CookieOptions;